export function createAction(type) {
    const action = payload => ({
        type: type.REQUEST,
        payload
    })
    return action
}